import { Fragment, useCallback, useEffect } from 'react';

import { useOrgsData, useOrgsMapFromOrgs } from 'app/dataProviders/org/OrgsDataProvider';
import OrgsAndGroupsSelector from 'app/components/common/OrgsAndGroupsSelector';

import useOrgsSelector from './useOrgsSelector';
import { OrgId } from 'app/common/types/id';


type Props = {
  orgIdFrom: OrgId,
  disabled: boolean,
  onChangeOrgsSelected: (ids: Array<string>) => void,
  resetErrors: () => void,
}

export const CopyKitFormOtherOrgs = ({
  orgIdFrom,
  disabled,
  onChangeOrgsSelected,
  resetErrors,
}: Props) => {

  const [{ orgs: orgsState, currentOrg }] = useOrgsData();
  const { type } = currentOrg;

  const orgsMap = useOrgsMapFromOrgs(orgsState);

  const orgId = parseInt(orgIdFrom, 10);
  const ignoreCurrent = useCallback(({ ID }: { ID: string }) => {
    return orgIdFrom !== ID;
  }, [orgIdFrom]);

  const [selectorProps] = useOrgsSelector(orgsState, { orgId });
  const { selection: orgsSelected, selection, defaultSelection, onChange } = selectorProps;


  useEffect(() => {
    onChangeOrgsSelected(orgsSelected);
  }, [orgsSelected]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Fragment>
      <OrgsAndGroupsSelector
        orgType={type}
        label="В заведения"
        header="Выберите куда копировать комплект"
        pleaseSelectText="Выберите заведение"
        // loading={loadingOrgs}
        disabled={disabled}
        orgs={orgsMap}
        multiple
        selectedAllOnEmptySelection={false}
        selection={selection}
        defaultSelection={defaultSelection}
        onChange={onChange}
        filterFunc={ignoreCurrent}
      />

      {/* {errors.org
        && <PlainHelperText overflowVisible error>
          {errors.org}
        </PlainHelperText>} */}

    </Fragment>
  )
}

